import { useSelector } from 'react-redux';
import { RootState } from '../store';

export interface FiscalDateRange {
  minDate: Date;
  maxDate: Date;
  startDateStr: string;
  endDateStr: string;
}

/**
 * Returns the date range of the currently selected fiscal period.
 * All entry-form DatePickers should be constrained to this range.
 */
export function useFiscalDateRange(): FiscalDateRange {
  const { availableFiscalYears, selectedFiscalYearId, currentFiscalYearId } =
    useSelector((state: RootState) => state.auth);

  const id = selectedFiscalYearId ?? currentFiscalYearId;
  const period = availableFiscalYears.find((fy) => fy.fiscalPeriodId === id);

  if (period) {
    return {
      minDate: new Date(period.startDate),
      maxDate: new Date(period.endDate),
      startDateStr: period.startDate.split('T')[0],
      endDateStr: period.endDate.split('T')[0],
    };
  }

  // Fallback: current year
  const year = new Date().getFullYear();
  return {
    minDate: new Date(year, 0, 1),
    maxDate: new Date(year, 11, 31),
    startDateStr: `${year}-01-01`,
    endDateStr: `${year}-12-31`,
  };
}
